import axios from "axios";
import * as models from './models.js'


export const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' }
});

const schemaMap = {
  'GET /status': models.StatusSchema,
  'GET /reps/next': models.RepetitionSchema
//   'GET /users': UsersListSchema,
//   'POST /users': UserSchema,
};

api.interceptors.response.use((response) => {
  const key = `${response.config.method.toUpperCase()} ${response.config.url}`;
  const schema = schemaMap[key];
  
  if (schema) {
    const validated = schema.safeParse(response.data)
    response.data = validated.data;
  }
  
  return response;
});